import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormikContext } from 'formik';
import { useCallback, useMemo } from 'react';
import { FaPlus, FaTimes } from 'react-icons/fa';
import { useChartData } from '../../../context/ChartContext';
import Button from '../../../elements/Button';
import { CheckBoxCell } from '../../../elements/CheckBoxCell';
import ReactTable from '../../../elements/ReactTable/ReactTable';
import FormikInput from '../../../elements/formik/FormikInput';
import { convertPathArrayToString } from '../../../utility/convertPathArrayToString';
import { getSpectraObjectPaths } from '../../../utility/getSpectraObjectPaths';
const styles = {
    input: {
        width: '100%',
        border: 'none',
        padding: 0,
        height: '100%',
        textAlign: 'left',
        borderRadius: 0,
    },
    column: {
        padding: '5px',
    },
};
function LegendsPreferences() {
    const { values, setFieldValue } = useFormikContext();
    const { data } = useChartData();
    const { datalist, paths } = useMemo(() => getSpectraObjectPaths(data), [data]);
    const fields = values?.legendsFields;
    const addHandler = useCallback((data, index) => {
        let columns = [];
        const emptyField = {
            jpath: null,
            visible: true,
        };
        if (data && Array.isArray(data)) {
            columns = [...data.slice(0, index), emptyField, ...data.slice(index)];
        }
        else {
            columns.push(emptyField);
        }
        void setFieldValue('legendsFields', columns);
    }, [setFieldValue]);
    const deleteHandler = useCallback((data, index) => {
        const _fields = data.filter((_, columnIndex) => columnIndex !== index);
        void setFieldValue('legendsFields', _fields);
    }, [setFieldValue]);
    const COLUMNS = useMemo(() => [
        {
            Header: '#',
            style: { width: '25px', ...styles.column },
            accessor: (_, index) => index + 1,
        },
        {
            Header: 'Field',
            Cell: ({ row }) => {
                const predefinedColumn = row.original;
                if (predefinedColumn?.name) {
                    return _jsx("p", { children: predefinedColumn.label });
                }
                return (_jsx(FormikInput, { name: `legendsFields.${row.index}.jpath`, style: { input: styles.input }, mapOnChangeValue: (key) => paths?.[key] || null, mapValue: (paths) => convertPathArrayToString(paths), datalist: datalist }));
            },
        },
        {
            Header: 'Visible',
            style: { width: '30px', ...styles.column },
            Cell: ({ row }) => (_jsx(CheckBoxCell, { name: `legendsFields.${row.index}.visible`, defaultValue: true })),
        },
        {
            Header: '',
            style: { width: '30px', ...styles.column },
            id: 'add-button',
            Cell: ({ data, row }) => {
                const record = row.original;
                return (_jsxs("div", { style: { display: 'flex' }, children: [_jsx(Button.Done, { fill: "outline", onClick: () => addHandler(data, row.index + 1), children: _jsx(FaPlus, {}) }), !record?.name && (_jsx(Button.Danger, { fill: "outline", onClick: () => deleteHandler(data, row.index), children: _jsx(FaTimes, {}) }))] }));
            },
        },
    ], [addHandler, datalist, deleteHandler, paths]);
    return (_jsx(ReactTable, { data: fields, columns: COLUMNS, style: { table: { height: '100%' } } }));
}
export default LegendsPreferences;
